export default __webpack_public_path__ + "static/media/planning.34262ef0.svg";